<div
    class="cmps-cdk-bg-color-white cmps-cdk-border-color-grey-300 cmps-cdk-border-solid cmps-cdk-border-width-1p cmps-cdk-min-w-768px"
>
    <div class="modal-header">
        <div
            class="modal-title h4"
            role="heading"
            aria-level="1"
        >
            {{ i18n._927_CONTINUE_YOUR_SESSION | translate }}
        </div>
        <button
            type="button"
            class="close"
            [attr.aria-label]="i18n._763_CLOSE | translate"
            (click)="_dialogRef.close(false)"
        >
            <cmps-icon svgIcon="close"></cmps-icon>
        </button>
    </div>
    <div class="modal-body">
        <cmps-auth-login [isReAuth]="true"></cmps-auth-login>
    </div>
</div>
